const PivotMatrix = (pivotType, queryType, defaultOptions) => {
  let options = defaultOptions;
  let incomingType = pivotType?.toLowerCase();

  switch (incomingType) {
    case 'ptr':
      if (queryType === 'query') {
        options[0].ptr4 = false;
        options[0].anyipv4 = false;
        options[1].a = false;
      } else if (queryType === 'answer') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      }
      return options;

    case 'ptr4':
      if (queryType === 'query') {
        options[0].ptr4 = false;
        options[0].anyipv4 = false;
        options[1].a = false;
      } else if (queryType === 'answer') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      }
      return options;

    case 'ptr6':
      if (queryType === 'query') {
        options[0].ptr6 = false;
        options[0].anyipv6 = false;
        options[1].aaaa = false;
      } else if (queryType === 'answer') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      }
      return options;

    case 'a':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[0].ptr4 = false;
        options[0].anyipv4 = false;
        options[1].a = false;
      }
      return options;

    case 'aaaa':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[0].ptr6 = false;
        options[0].anyipv6 = false;
        options[1].aaaa = false;
      }
      return options;

    case 'ns':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].ns = false;
      }
      return options;

    case 'mx':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].mx = false;
      }
      return options;

    case 'mxsrv':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].mx = false;
      }
      return options;

    case 'soa':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[1].soa = false;
      }
      return options;

    case 'txt':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[1].txt = false;
      }
      return options;

    case 'cname':
      if (queryType === 'query' || queryType === 'answer') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      }
      return options;

    case 'host':
      if (queryType === 'query' || queryType === 'answer') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      }
      return options;

    case 'nssrv':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].ns = false;
      }
      return options;

    case 'ipv4':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[0].ptr4 = false;
        options[0].anyipv4 = false;
        options[1].a = false;
      }
      return options;

    case 'ipv6':
      if (queryType === 'query') {
        options[0].any = false;
        options[0].a = false;
        options[0].aaaa = false;
        options[0].cname = false;
        options[0].mx = false;
        options[0].ns = false;
        options[0].soa = false;
        options[0].txt = false;
        options[1].cname = false;
        options[1].mx = false;
        options[1].ns = false;
        options[1].ptr4 = false;
        options[1].ptr6 = false;
      } else if (queryType === 'answer') {
        options[0].ptr6 = false;
        options[0].anyipv6 = false;
        options[1].aaaa = false;
      }
      return options;

    case 'txthash':
      if (queryType === 'answer') {
        options[1].txthash = false;
      }
      return options;

    case 'mxhash':
      if (queryType === 'answer') {
        options[1].mxhash = false;
      }
      return options;

    case 'nshash':
      if (queryType === 'answer') {
        options[1].nshash = false;
      }
      return options;

    case 'soahash':
      if (queryType === 'answer') {
        options[1].soahash = false;
      }
      return options;

    //fallback allow all options
    case 'query':
      if (queryType === 'query') {
        for (const key in options) {
          options[key] = false;
        }
      } else if (queryType === 'answer') {
        for (const key in options) {
          options[key] = false;
        }
      }
      return options;

    //fallback allow all options
    default:
      if (queryType === 'query') {
        for (const key in options) {
          options[key] = false;
        }
      } else if (queryType === 'answer') {
        for (const key in options) {
          options[key] = false;
        }
      }
      return options;
  }
};

export default PivotMatrix;
